module.exports = __webpack_public_path__ + "media/images/patient-icons/patient-info-Icon-blue-b2eb146079f19d5e8e5e59a33cb80f92.svg";